class MobileSearchToggle {
  constructor() {
    this.toggleButton = document.querySelector(".js-mobile-search-toggle");
    this.closeButton = document.querySelector(".js-masthead-close-search-toggle");
    this.searchSection = document.querySelector(".js-mobile-search-section");
    this.searchIcon = this.toggleButton?.querySelector("svg");
  }

  init() {
    if (!this.searchSection) {
      return;
    }

    this.setupToggleButton();
    this.setupCloseButton();
  }

  setupToggleButton() {
    if (!this.toggleButton || !this.searchIcon) {
      return;
    }

    // Ensure proper button semantics
    if (this.toggleButton.tagName !== "BUTTON") {
      this.toggleButton.setAttribute("role", "button");
      this.toggleButton.setAttribute("tabindex", "0");

      // Add keyboard handler for non-button elements
      this.toggleButton.addEventListener("keydown", e => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this.toggleButton.click();
        }
      });
    }

    // Initialize ARIA attributes
    this.toggleButton.setAttribute("aria-expanded", "false");
    this.searchSection.setAttribute("aria-hidden", "true");

    this.toggleButton.addEventListener("click", () => {
      const isHidden = this.searchSection.classList.toggle("hidden");

      // Update ARIA states
      this.toggleButton.setAttribute("aria-expanded", !isHidden);
      this.searchSection.setAttribute("aria-hidden", isHidden);

      if (isHidden) {
        this.searchIcon.classList.remove("text-blue-600");
        // Return focus to toggle when closing
        this.toggleButton.focus();
      } else {
        this.searchIcon.classList.add("text-blue-600");
      }
    });
  }

  setupCloseButton() {
    if (!this.closeButton) {
      return;
    }

    this.closeButton.addEventListener("click", () => {
      this.searchSection.classList.add("hidden");

      // Update ARIA states
      if (this.toggleButton) {
        this.toggleButton.setAttribute("aria-expanded", "false");
      }
      this.searchSection.setAttribute("aria-hidden", "true");

      if (this.searchIcon) {
        this.searchIcon.classList.remove("text-blue-600");
      }

      // Return focus to toggle button
      if (this.toggleButton) {
        this.toggleButton.focus();
      }
    });
  }
}

const initMobileSearchToggle = () => {
  new MobileSearchToggle().init();
};

export default initMobileSearchToggle;
